import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { ItemService } from '../../item-detail/item-detail.service';
import { ReCaptchaV3Service, RecaptchaModule, RecaptchaV3Module } from 'ng-recaptcha';

@Component({
  selector: 'app-home-contact-us',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RecaptchaV3Module,RecaptchaModule,FormsModule],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class HomeContactUsComponent {
  thankyou = false;
  f = this.fb.group({
    name: [null, Validators.required],
    email: [null, [Validators.required, Validators.email]],
    phone: [null, [Validators.required, Validators.minLength(10), Validators.maxLength(11)]],
    message: [null, [Validators.required, Validators.minLength(15), Validators.maxLength(250)]],
  })

  submitContactUs() {
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token) => {


        this.itemService.postContactUs(this.f.value,token).subscribe(w => {
          this.f.reset()
          this.thankyou = true
          setTimeout(() => {
            this.thankyou = false

          }, 2000)
        })
      });
  }
  playAudio() {
    this.t.click()
    // const audio = new Audio();
    // audio.src = '../../../../assets/branding/Gun-Cocking-www.fesliyanstudios.com.mp3';
    // audio.volume = .10;
    // audio.load();
    // audio.play();
  }


  t: HTMLButtonElement;
  constructor(@Inject(DOCUMENT) private document: Document, private recaptchaV3Service: ReCaptchaV3Service,
   private fb: FormBuilder, private itemService: ItemService) {
    this.t = this.document.createElement('button')
    this.t.id = 'mu6'
    this.t.onclick = (a) => {
      // alert('123')
      const mu6 = this.document.createElement('audio')
      mu6.src = '../assets/branding/Gun-Cocking-www.fesliyanstudios.com.mp3';
      mu6.preload = 'auto'
      mu6.play();

      // const audio = new Audio();
      // audio.src = 'assets/branding/menu.wav';
      // audio.volume = .10;
      // audio.load();
      // audio.play();

    }
  }
}
